import Inputmask from "inputmask";

document.addEventListener('DOMContentLoaded', () => {
    const times = document.querySelectorAll('.js-time');
    times.forEach((time, index) => {
        Inputmask("datetime",{
            inputFormat: "HH:MM",
            showMaskOnHover: false,
            placeholder: '_'
        }).mask(time);
    });
});
